import React from 'react';
import { Check, X } from 'lucide-react';
import { useAccessTheme } from '../useAccessTheme';
import type { FeatureBadge, ProviderStatus } from './identityProviderTypes';

const STATUS_LABEL: Record<ProviderStatus, string> = {
  connected: 'Connected',
  'not-connected': 'Not Connected',
  syncing: 'Syncing',
  error: 'Error',
};

export function ProviderStatusBadge({ status }: { status: ProviderStatus }) {
  const t = useAccessTheme();
  const label = STATUS_LABEL[status];

  const tone =
    status === 'connected'
      ? t.isLight
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
        : 'bg-emerald-900/30 text-emerald-300 border-emerald-700/50'
      : status === 'syncing'
        ? t.badgeAccent
        : status === 'error'
          ? t.errorBox
          : t.badge;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md border ${tone}`}>
      {label}
    </span>
  );
}

export function FeatureBadgeChip({ label }: { label: FeatureBadge }) {
  const t = useAccessTheme();
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs rounded-md border ${t.badge}`}>
      {label}
    </span>
  );
}

export function CapabilityCheckList({
  items,
  variant = 'allow',
}: {
  items: string[];
  variant?: 'allow' | 'deny';
}) {
  const t = useAccessTheme();
  const deny = variant === 'deny';
  return (
    <ul className="space-y-2">
      {items.map((item) => (
        <li key={item} className={`flex items-center gap-2 text-sm ${t.body}`}>
          {deny ? (
            <X className="w-4 h-4 shrink-0 text-red-500" />
          ) : (
            <Check className={`w-4 h-4 shrink-0 ${t.toggleOn}`} />
          )}
          {item}
        </li>
      ))}
    </ul>
  );
}
